/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from "react";
import { commonServices } from "../../../../api/services/commonServices";
import { userService } from "../../../../api/services/userService";
import { getBankInfoReducer } from "../../../../infra/aggregates/myProfile/bankInfoSlice";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";

interface PropsValues {
  setBankInfo: (data: any) => void;
  setBank_Fields: (data: any) => void;
  setExchange_Fields: (data: any) => void;
}

function DTOPersonalInfo({
  setBankInfo,
  setBank_Fields,
  setExchange_Fields,
}: PropsValues) {
  const selector = useAppSelector((state) => state.authSlice);
  const storedBankInfo = useAppSelector(
    (state) => state.bankInfoSlice.bank_details
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    commonServices
      .getPayoutBankFields(selector.company_id)
      .then((res: any) => {
        setBank_Fields(res?.data);
      })
      .catch((err) => console.log(err));
    commonServices
      .getPayoutExchangeFields(selector.company_id)
      .then((res: any) => {
        setExchange_Fields(res?.data);
      })
      .catch((err) => console.log(err));
    userService
      .getBankDetail(selector.company_id, selector.emp_id)
      .then((res: any) => {
        if (res?.response == "success") {
          dispatch(getBankInfoReducer(res?.data));
          setBankInfo(res?.data);
        } else {
          return;
        }
      })
  }, []);
  
  useEffect(() => {
    setBankInfo(storedBankInfo);
  }, [storedBankInfo]);

  return <></>;
}
export default DTOPersonalInfo;
